import React from "react";
import { FinanceType } from "../../../../models/finance/FinanceType";
import ReportDTO from "../../../../models/finance/Reports";
import MonthlyReportsComponent from "../monthly/MonthlyReportsComponent";

interface IncomesMonthlyReportsComponentPropos {
  report: ReportDTO;
  year: number;
  month: string;
}

const IncomesMonthlyReportsComponent: React.FC<
  IncomesMonthlyReportsComponentPropos
> = ({ report, year, month }) => {
  return (
    <>
      <MonthlyReportsComponent
        year={year}
        month={month}
        report={report}
        type={FinanceType.INCOME}
      />
    </>
  );
};

export default IncomesMonthlyReportsComponent;
